export default __webpack_public_path__ + "static/media/well-documented-code-icon.74f5b662.svg";